export const ORDER_ITEM_LIST = "ORDER_ITEM_LIST"
export const ORDER_ITEM_DETAIL = "ORDER_ITEM_DETAIL"
export const ORDER_ITEM_CREATE = "ORDER_ITEM_CREATE"
export const ORDER_ITEM_UPDATE = "ORDER_ITEM_UPDATE"
export const ORDER_ITEM_DELETE = "ORDER_ITEM_DELETE"
export const UPDATE_ITEM_INSTOCK_STATUS = "UPDATE_ITEM_INSTOCK_STATUS"
